module.exports = __webpack_public_path__ + "img/img_033@2x.0cec698a.png";